(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.vantSlots = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Use scopedSlots in Vue 2.6+
   * downgrade to slots in lower version
   */
  var SlotsMixin = exports.SlotsMixin = {
    methods: {
      slots: function slots() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var props = arguments[1];
        var $slots = this.$slots,
            $scopedSlots = this.$scopedSlots;

        var scopedSlot = $scopedSlots[name];

        if (scopedSlot) {
          return scopedSlot(props);
        }

        return $slots[name];
      }
    }
  };
});